import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Film, Clock, Star, MessageSquare, Gamepad2, Zap } from 'lucide-react';

export function Rewards() {
  const { t } = useTranslation();
  const rewards = [
    { Icon: Film,         title: t('rewards.r1_title'), desc: t('rewards.r1_desc'), accent: 'gold' },
    { Icon: Clock,        title: t('rewards.r2_title'), desc: t('rewards.r2_desc'), accent: 'xp' },
    { Icon: Star,         title: t('rewards.r3_title'), desc: t('rewards.r3_desc'), accent: 'gold' },
    { Icon: MessageSquare,title: t('rewards.r4_title'), desc: t('rewards.r4_desc'), accent: 'kquest' },
    { Icon: Gamepad2,     title: t('rewards.r5_title'), desc: t('rewards.r5_desc'), accent: 'xp' },
    { Icon: Zap,          title: t('rewards.r6_title'), desc: t('rewards.r6_desc'), accent: 'kquest' },
  ] as const;

  return (
    <section className="section bg-kquest-900/40 relative overflow-hidden">
      <div className="absolute inset-0 bg-blocks pointer-events-none opacity-50" />
      <div className="absolute top-1/3 right-0 w-[600px] h-[600px] bg-gold-500/10 rounded-full blur-[140px] pointer-events-none" />

      <div className="relative container-narrow">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="font-pixel text-4xl sm:text-5xl font-bold tracking-tight">
            {t('rewards.title')}
          </h2>
          <p className="mt-4 text-kquest-300 text-lg">{t('rewards.subtitle')}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {rewards.map((r, i) => (
            <motion.div
              key={r.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="kblock enchant-card p-6 group relative"
            >
              <div className={`inline-flex w-12 h-12 items-center justify-center mb-4 border-2 ${accentBg(r.accent)}`}
                   style={{ boxShadow: 'inset 0 -3px 0 0 rgba(0,0,0,0.4), inset 0 3px 0 0 rgba(255,255,255,0.12)' }}>
                <r.Icon className="w-6 h-6 text-kquest-950" strokeWidth={2.2} />
              </div>
              <h3 className="font-pixel text-lg font-semibold mb-2 text-kquest-100">{r.title}</h3>
              <p className="text-sm text-kquest-300 leading-relaxed">{r.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

function accentBg(a: 'gold' | 'xp' | 'kquest') {
  return {
    gold: 'bg-gold-500 border-gold-700',
    xp: 'bg-xp-500 border-xp-700',
    kquest: 'bg-kquest-grad border-kquest-700',
  }[a];
}
